import { Platform, StyleSheet } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { getWindowDimensions } from '../Utils/Helpers';

export default StyleSheet.create({
  containerStyle: {
    paddingHorizontal: 16.3,
    paddingBottom: 112,
  },
  headerTitle: theme => ({
    fontWeight: 'bold',
    fontSize: 24,
    lineHeight: 30,

    color: theme.colors.headerColor,
    ...Platform.select({
      ios: {
        marginTop: getWindowDimensions.height < 800 ? 12 : 25,
      },
      android: {
        marginTop: 16,
      },
    }),
  }),
  headerSubTitle: theme => ({
    fontSize: 16,
    color: theme.colors.headerColor,
    marginVertical: 16,
  }),
  cardContainerStyle: isUpgradeAvailable => ({
    paddingTop: 10,
    paddingBottom: isUpgradeAvailable ? 16 : 24,
    marginBottom: 16,
    paddingHorizontal: 10,
  }),
  headerTitleEmptyDevices: {
    fontSize: 19,
    marginTop: 10,
  },
  emptyDeviceContent: {
    height: '100%',
    textAlign: 'center',
    alignItems: 'center',
    marginTop: 25,
  },
  emptyDevicesImage: {
    width: 105,
    height: 105,
  },
  headerSubTitleEmptyDevices: { fontSize: 16, lineHeight: 30, color: Colors.thinDark },

  errorIconStyle: {
    marginTop: getWindowDimensions.height > 700 ? -140 : 0,
  },
  fullScreenError: {
    backgroundColor: Colors.transparent,
    height: getWindowDimensions.height * 0.45,
    width: '100%',
    justifyContent: 'center',
  },
});
